import React, { useEffect } from 'react';
import client from '../../appolloConfig';
import useGoToPage from '../../hooks/useGoToPage';
import pages from '../../routes/pages';
import { ButtonWithText } from '../../components/atoms/Buttons/ButtonWithText';

const Logout = () => {
  useEffect(() => {
    client.resetStore();
    localStorage.clear();
  }, []);

  const to = useGoToPage(pages.HOME_PAGE.path);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '20px',
        height: '100vh'
      }}
    >
      <h2>
        Vous êtes déconnecté{' '}
        <span role="img" aria-label="oups">
          😕
        </span>
      </h2>
      <ButtonWithText
        content={"Revenir à l'accueil"}
        onClick={to}
        icon={'Home'}
      />
    </div>
  );
};
export default Logout;
